import { render, staticRenderFns } from "./recipe-cna-download.vue?vue&type=template&id=7c313878&scoped=true&"
import script from "./recipe-cna-download.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-download.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-download.vue?vue&type=style&index=0&id=7c313878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c313878",
  null
  
)

export default component.exports